import { addressDrawerApplyButtonStyles as styles } from "@insite/content-library/Widgets/Header/AddressDrawerApplyButton";
import { css } from "styled-components";

styles.gridItem = {
    ...styles.gridItem,
    css: css`
        ${styles.gridItem?.css}
        justify-content: flex-start;
    `,
};
